import { isSameDay } from 'date-fns';
import React from 'react';
import { useToday } from 'shared/contexts/today';
import { Task } from 'shared/types/task';
import { Timestamp } from 'shared/types/timestamp';

import { DayEntry } from '../upcoming/types';
import { AddSlot } from './add-slot';
import { EntrySlot } from './entry-slot';
import { UntilCompletedSlot } from './until-completed-slot';

export type UpcomingSlotProps = {
  task: Task;
  date: Timestamp;
  entry?: DayEntry;
  isOverdue?: boolean;
};

export const UpcomingSlot: React.FC<UpcomingSlotProps> = ({
  task,
  date,
  entry,
}) => {
  const today = useToday();
  const isToday = isSameDay(date, today);

  const hasEntryState = !!entry?.state;

  return (
    <>
      {(!entry?.isGeneratedFrequencyEntry || isToday || hasEntryState) &&
        (entry ? (
          <EntrySlot task={task} date={date} entry={entry} />
        ) : (
          <AddSlot task={task} date={date} />
        ))}
      {entry?.isGeneratedFrequencyEntry && !hasEntryState && (
        <UntilCompletedSlot task={task} date={date} entry={entry} />
      )}
    </>
  );
};
